import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { defaultTo, filter, compose, not, isNil, path } from 'ramda';

import Accordion from '../../../../../components/Accordion/index';
import Step from '../../../../../components/Accordion/Step';
import { Membership, Donation, TrainingSummary } from '../Steps/index';
import PreRegistrationProgressIndicator from '../Steps/Components/PreRegistrationProgressIndicator';

class TrainingPreRegistration extends Component {
  static propTypes = {
    donations: PropTypes.array,
    training: PropTypes.object,
    memberships: PropTypes.array,
    registration: PropTypes.object,
    user: PropTypes.object,
  };

  static defaultProps = {
    registration: {},
  };

  state = {
    percentageComplete: 0,
  };

  render() {
    const { training, registration, user } = this.props;
    const { percentageComplete } = this.state;
    const reviews = defaultTo([], registration.reviews);
    const isActiveMember = path(['membership', 'valid'], user);

    const steps = filter(compose(not, isNil), [
      isActiveMember ? null : { as: Membership, name: 'membership', title: 'Membership (optional)' },
      { as: Donation, name: 'donation', title: 'Donation (optional)' },
      { as: TrainingSummary, name: 'summary', title: 'Pay & Review' },
    ]);

    return (
      <div className="row">
        <PreRegistrationProgressIndicator
          container={this}
          name={training.name}
          reviews={reviews}
          percentageComplete={percentageComplete}
        />
        <div className="col-xs-12 col-sm-8">
          <Accordion
            step={registration.step}
            onPercentageChanged={(percent) => this.setState({ percentageComplete: percent })}
          >
            {steps.map((step) => (
              <Step key={step.name} {...step} {...this.props} />
            ))}
          </Accordion>
        </div>
      </div>
    );
  }
}

export default TrainingPreRegistration;
